import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import * as debugLib from "debug";

const debug = debugLib("app:pages/company/item/list/Modal");

const ItemQRCodeGeneratorModal = (props) => {
  // To translate English to Chinese and vice versa with respect to Application's Language Selected
  const { t } = useTranslation();

  // Getting all the props
  const {
    selectedRecord,
    QRCodeModalVisible,
    setQRCodeModalVisible,
  } = props;

  // Converting the property ID .i.e. item_id to string so that QR code can be generated
  let num = selectedRecord.item_id || selectedRecord.order_id
  let stringNum = num ? num.toString() : '';

  return (
    // Creating a modal to view the QR code
    <Modal
      title={t("generate_qr_code")}
      visible={QRCodeModalVisible}
      footer={null}
      width={1000}
      style={{ maxWidth: "95%" }}
      onCancel={() => {
        setQRCodeModalVisible(false);
      }}
    >
      {/* Generating the QR code */}
      <div style={
        {
          height: "auto", margin: "0 auto", maxWidth: 94, width: "100%"
        }
        }
      >
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "200%", width: "200%" }}
          value={stringNum}
          viewBox="0 0 256 256"
        />
      </div>
    </Modal>
  );
};

export default ItemQRCodeGeneratorModal;
